import { createContext, useContext } from "react";
const FieldValidationContext = createContext(null);
const useFieldValidation = () => useContext(FieldValidationContext) || {};
export {
  FieldValidationContext,
  useFieldValidation
};
//# sourceMappingURL=field-validation-context.js.map
